import "web/script/polyfills";

import baustein from "baustein";
import jinjaToJs from "jinja-to-js";
import { initialiseReact } from "web/react/main";
import analytics from "web/script/analytics/analytics";
import "web/script/components/index";
import { installJinjaFilters } from "web/script/modules/jinja-filters";
import { installJinjaGlobals } from "web/script/modules/jinja-globals";
import userProfiler from "web/script/modules/userprofiler";
import alerts from "web/script/utils/alerts";
import browser from "web/script/utils/browser";
import history from "web/script/utils/history";
import loadFonts from "web/script/utils/load-fonts";

loadFonts();
installJinjaFilters(jinjaToJs);
installJinjaGlobals(jinjaToJs);

analytics.init();
userProfiler.init();
browser.init();
alerts.init();
baustein.init();

history.start();

analytics.pageView();
initialiseReact();
// we expose this as a global so 3rd parties can interact with our analytics
window.lystAnalytics = {
    event: analytics.event.bind(analytics),
};
